import React from "react";
import { Card } from "react-bootstrap";

import { NoRecordCard } from "../../../common/components";
import { Table } from "../../../common/components/core";
import { PaymentReceiptState } from "../../../types/payment";
import { formatAmount } from "../../../utils/amount";
import { formatToDate } from "../../../utils/common";
import { comparePaymentEntryDateDateDesc } from "../../../utils/payment";

type ReceiptProps = {
    receipts: PaymentReceiptState[];
    onReceiptClick: (txn: PaymentReceiptState) => void;
};

const ReceiptList = ({
    receipts,
    onReceiptClick,
}: ReceiptProps): JSX.Element => {
    const sortedReceipts = [...receipts].sort(comparePaymentEntryDateDateDesc);
    return sortedReceipts.length === 0 ? (
        <NoRecordCard />
    ) : (
        <Card className="mt-3 border-0">
            <Card.Body className="p-0">
                <table className={'custom-table'}>
                    <thead>
                        <tr>
                            <Table.HeaderCell width={150}>
                                Transaction Date
                            </Table.HeaderCell>
                            <Table.HeaderCell width={200}>
                                Transaction Reference Number
                            </Table.HeaderCell>
                            <Table.HeaderCell width={200}>
                                Beneficiary Bank Account
                            </Table.HeaderCell>
                            <Table.HeaderCell width={150} className="text-end">
                                Amount
                            </Table.HeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedReceipts.map((txn) => (
                            <Table.BodyRow
                                key={txn.referenceId}
                                onClick={() => onReceiptClick(txn)}
                                onKeyUp={(event:KeyboardEvent) =>
                                    {(event.keyCode === 13 || event.keyCode === 32) &&
                                        onReceiptClick(txn)
                                    }
                                }
                            >
                                <td>{formatToDate(txn.entryDate)}</td>
                                <td>{txn.transactionRefNum}</td>
                                <td>{txn.toAccount.accountNumber}</td>
                                <td className="text-end">
                                    {formatAmount(txn.amountMinor)}{" "}
                                    {txn.currency}
                                </td>
                            </Table.BodyRow>
                        ))}
                    </tbody>
                </table>
            </Card.Body>
        </Card>
    );
};

export default ReceiptList;
